import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { SnackbarService } from './snackbar.service';

export enum SnackbarType {
  ERROR = 'error',
  ALERT = 'alert',
  INFO = 'info',
}

@Component({
  selector: 'lib-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss',
  imports: [CommonModule, MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent {
  private snackbarService = inject(SnackbarService);

  /** RID-1355 — the whole stack, rendered one banner under another. */
  banners = computed(() =>
    this.snackbarService.banners().map((banner) => ({
      id: banner.id,
      title: banner.title,
      subtitle: banner.subTitle,
      dismissible: banner.dismissible ?? false,
      config: this.config[banner.type],
    })),
  );

  close(id: number): void {
    this.snackbarService.dismiss(id);
  }

  private config = {
    [SnackbarType.ERROR]: {
      icon: 'ico_info',
      type: 'error',
    },
    [SnackbarType.ALERT]: {
      icon: 'ico_soft',
      type: 'alert-warning',
    },
    [SnackbarType.INFO]: {
      icon: 'ico_info',
      type: 'info',
    },
  };
}
